import Vue from 'vue'
import Vuex from 'vuex'
import { mutations } from './mutation'
import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import userInfo from './modules/userInfo'
import msgBadge from './modules/msgBadge'
import configInfo from './modules/configInfo'
import createPersistedState from 'vuex-persistedstate'
import face from './modules/face'
import h5Config from './modules/h5Config'
// import keepAliveComponent from './modules/keepaliveComponent'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.localStorage,
    reducer (val) {
      return {
        userInfo: val.userInfo,
        pianoTypeList: val.pianoTypeList,
        msgBadge: val.msgBadge,
        configInfo: val.configInfo,
        face: val.face,
        h5Config: val.h5Config
      }
    }
  })],
  mutations: mutations,
  state: state,
  getters: getters,
  actions: actions,
  modules: {
    userInfo,
    msgBadge,
    configInfo,
    face,
    h5Config
  }
})
